import React, { useRef, useState, useEffect } from 'react';

// Import your images
import Unsere_Galerie1 from '../../src/images/Galerie/1.jpg'
import Unsere_Galerie2 from '../../src/images/Galerie/2.jpg'
import Unsere_Galerie3 from '../../src/images/Galerie/3.jpg'
import Unsere_Galerie4 from '../../src/images/Galerie/4.jpg'
import Unsere_Galerie5 from '../../src/images/Galerie/5.jpg'
import Unsere_Galerie6 from '../../src/images/Galerie/6.jpg'
import Unsere_Galerie7 from '../../src/images/Galerie/7.jpg'
import Unsere_Galerie8 from '../../src/images/Galerie/8.jpg'
import Unsere_Galerie9 from '../../src/images/Galerie/9.jpg'
import Unsere_Galerie10 from '../../src/images/Galerie/10.jpg'
import Unsere_Galerie11 from '../../src/images/Galerie/11.jpg'
import Unsere_Galerie12 from '../../src/images/Galerie/12.jpg'
import Unsere_Galerie13 from '../../src/images/Galerie/13.jpg'
import Unsere_Galerie14 from '../../src/images/Galerie/14.jpg'
import leftArrow from '../../src/images/Galerie/left-arrow.png'
import rightArrow from '../../src/images/Galerie/right-arrow.png'
const Gallery = () => {
    const galleryRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [autoSlideInterval, setAutoSlideInterval] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => {
            goToNextSlide();
        }, 3000);
        setAutoSlideInterval(interval);

        return () => clearInterval(interval);
    }, []);

    const goToSlide = (slideIndex) => {
        setCurrentSlide(slideIndex);
        clearInterval(autoSlideInterval);
    };

    const goToPrevSlide = () => {
        const prevSlide = (currentSlide - 2 + slideItems.length) % slideItems.length;
        goToSlide(prevSlide);
    };

    const goToNextSlide = () => {
        const nextSlide = (currentSlide + 2) % slideItems.length;
        goToSlide(nextSlide);
    };

    const slideItems = [
        { id: 1, src: Unsere_Galerie1, title: ' Unsere Galerie 1' },
        { id: 2, src: Unsere_Galerie2, title: ' Unsere Galerie 2' },
        { id: 3, src: Unsere_Galerie3, title: ' Unsere Galerie 3' },
        { id: 4, src: Unsere_Galerie4, title: ' Unsere Galerie 4' },
        { id: 5, src: Unsere_Galerie5, title: ' Unsere Galerie 5' },
        { id: 6, src: Unsere_Galerie6, title: ' Unsere Galerie 6' },
        { id: 7, src: Unsere_Galerie7, title: ' Unsere Galerie 7' },
        { id: 8, src: Unsere_Galerie8, title: ' Unsere Galerie 8' },
        { id: 9, src: Unsere_Galerie9, title: ' Unsere Galerie 9' },
        { id: 10, src: Unsere_Galerie10, title: ' Unsere Galerie 10' },
        { id: 11, src: Unsere_Galerie11, title: ' Unsere Galerie 11' },
        { id: 12, src: Unsere_Galerie12, title: ' Unsere Galerie 12' },
        { id: 13, src: Unsere_Galerie13, title: ' Unsere Galerie 13' },
        { id: 14, src: Unsere_Galerie14, title: ' Unsere Galerie 14' },
    ];

    return (
        <div className="container mx-auto px-4">
            <div id="default-carousel" className="relative w-full flex justify-center" data-carousel="slide">
                <div className="absolute left-0 top-0 z-30 flex items-center justify-center h-full px-4 group focus:outline-none text-red-500">
                    <button type="button" className="h-12" data-carousel-prev onClick={goToPrevSlide}>
                        <img src={leftArrow} alt="Previous Button" className="w-12 h-12" />
                    </button>
                </div>
                <div className="relative h-56 overflow-hidden rounded-lg md:h-96 w-10/12">
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                        {slideItems.map((item, index) => (
                            <div
                                key={item.id}
                                className={`duration-700 ease-in-out ${index >= currentSlide && index < currentSlide + 4 ? 'block' : 'hidden'
                                    }`}
                                data-carousel-item
                            >
                                <img
                                    src={item.src}
                                    className="w-full h-full object-cover"
                                    alt={`Slide ${index + 1}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="absolute right-0 top-0 z-30 flex items-center justify-start h-full px-4 group focus:outline-none text-red-500">
                    <button type="button" className="h-12" data-carousel-next onClick={goToNextSlide}>
                        <img src={rightArrow} alt="Previous Button" className="w-12 h-12" />
                    </button>
                </div>
            </div>
        </div>

    );
};

export default Gallery;
